export const DownloadAsCsv = (
  jsonData: any[],
  filename: string = "data.csv",
) => {
  if (!jsonData.length) return;

  const headers = Object.keys(jsonData[0]);

  const csvRows = [
    headers.join(","),
    ...jsonData.map((row) =>
      headers.map((header) => JSON.stringify(row[header] ?? "")).join(","),
    ),
  ].join("\n");

  const blob = new Blob([csvRows], { type: "text/csv" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
